










































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';
import pricingServices from '@/services/pricing-services';

@Component
export default class PricingDetail extends Vue {
    @Prop({default: {}})
    private listWeightPrice: any;
    @Prop({default: {}})
    private listVolumePrice: any;

    get configuration() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].configuration;
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get productTypes()  {
        if (this.configuration && this.configuration.ProductTypes) {
            return JSON.parse(this.configuration.ProductTypes);
        }
        return [];
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private getProductTypeName(value: number) {
        if (this.productTypes.length === 0) {
            return '';
        }

        const type = this.productTypes.find((p) => p.value === value);
        return type ? type.name : '';
    }

    private getStoreName(value: number) {
        if (!this.warehouse || this.warehouse.length === 0) {
            return '';
        }

        const type = this.warehouse.find((p) => p.ID === value);
        return type ? type.Name : '';
    }
}
